import axios from "axios";
import { Toast } from "vant";

// 读取环境配置获取接口地址
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;

//请求头
axios.defaults.headers.post["Content-Type"] = "application/json";

//设置超时
axios.defaults.timeout = 30000;

axios.interceptors.request.use(
  config => {
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  response => {
    if (response.status == 200) {
      if (response.data.code == 0) {
        return Promise.resolve(response);
      } else if (response.data.code == -999) {
        localStorage.removeItem('token')
        return Promise.reject(response);
      } else {
        // Toast(response.data.message)
        return Promise.resolve(response);
      }
    } else {
      return Promise.reject(response);
    }
  },
  error => {

  }
);

export default {

  post(url, data) {
    // localStorage.setItem("token", '5c5ee9762cec4298ae4c9dd70eb59636')
    // localStorage.setItem("token", 'TEST-1')
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url,
        headers: {
          "X-Token": localStorage.getItem("token") == null ? '' : localStorage.getItem("token")
        },
        data: data,
      })
        .then(res => {
          resolve(res.data)
        })
        .catch(err => {
          reject(err)
        });
    })
  },

  get(url, data) {
    // localStorage.setItem("token", '5c5ee9762cec4298ae4c9dd70eb59636')
    // localStorage.setItem("token", 'TEST-1')

    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url,
        headers: {
          "X-Token": localStorage.getItem("token") == null ? '' : localStorage.getItem("token")
        },
        params: data,
      })
        .then(res => {
          resolve(res.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
};
